module.exports = __webpack_public_path__ + "static/media/card-visa-logo.bd687161.svg";